module.exports = __webpack_public_path__ + "img/mh.fe2992a7.svg";